


export default {
    name: 'historique-analyse-biologique',
    components: {
        
    },
    props: {
        historique: Object,
    },
    data() {
        return {
            demande_analyse: {},
            results: null,
            view_result_loading: false,
        }
    },

    computed: {

    },

    mounted() {
        this.$store.commit("SET_RESULAT_PATIENT_TO_PRINT", {})
        this.$store.commit("SET_CAN_PRINT_RESULT", false)
    },

    methods: {
        viewResult(demande_analyse, historique) {
            const param_result = {
                demande_analyse: demande_analyse,
                evolution_id: historique.evolution_id
            }
            if (!this.is_modele_analyse) {
                this.demande_analyse = demande_analyse
                this.results = null;
                this.$emit('emitViewResultUploaded', param_result)
            } else {
                if (demande_analyse.resultat_est_porte == 1 && demande_analyse.resultat_fichier != null) {
                    this.demande_analyse = demande_analyse
                    this.results = null;
                    this.$emit('emitViewResultUploaded', param_result)
                } else {
                    const param_result = {
                        demande_analyse: demande_analyse,
                        historique: historique
                    }
                    this.$emit('emitOpenResultModal', param_result)
                }
            }
        },
    }
}


